import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

export const cardHeaderStyle = css`
    padding: 24px 24px 10px;
`;

export const inputSectionStyle = css`
    margin: 0 24px 16px;
    padding-top: 0;
`;

export const modalStyle = css`
    div > div.ant-modal-footer {
        background-color: #f7f8f9;
        border-top: none;
    }
`;

export const confirmRemovalModalStyle = css`
    ${modalStyle};

    div > button.primary {
        background-color: ${Colors.Red.V150} !important;
    }
`;
